function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module link/linkimageediting
 */
import { Plugin } from 'ckeditor5/src/core';
import { Matcher } from 'ckeditor5/src/engine';
import { toMap } from 'ckeditor5/src/utils';
import LinkEditing from './linkediting';
/**
 * The link image engine feature.
 *
 * It accepts the `linkHref="url"` attribute in the model for the {@link module:image/image~Image `<imageBlock>`} element
 * which allows linking images.
 *
 * @extends module:core/plugin~Plugin
 */

var LinkImageEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(LinkImageEditing, _Plugin);

  var _super = _createSuper(LinkImageEditing);

  function LinkImageEditing() {
    _classCallCheck(this, LinkImageEditing);

    return _super.apply(this, arguments);
  }

  _createClass(LinkImageEditing, [{
    key: "init",
    value: function init() {
      var editor = this.editor;
      var schema = editor.model.schema;

      if (editor.plugins.has('ImageBlockEditing')) {
        schema.extend('imageBlock', {
          allowAttributes: ['linkHref']
        });
      }

      if (editor.plugins.has('ImageInlineEditing')) {
        schema.extend('imageInline', {
          allowAttributes: ['linkHref']
        });
      }

      editor.conversion.for('upcast').add(upcastLink(editor));
      editor.conversion.for('downcast').add(downcastImageLink); // Definitions for decorators are provided by the `link` command and the `LinkEditing` plugin.

      this._enableAutomaticDecorators();

      this._enableManualDecorators();
    }
    /**
     * Processes {@link module:link/link~LinkDecoratorAutomaticDefinition automatic decorators} definitions and
     * attaches proper converters that will work when linking an image.`
     *
     * @private
     */

  }, {
    key: "_enableAutomaticDecorators",
    value: function _enableAutomaticDecorators() {
      var editor = this.editor;
      var command = editor.commands.get('link');
      var automaticDecorators = command.automaticDecorators;

      if (automaticDecorators.length) {
        editor.conversion.for('downcast').add(automaticDecorators.getDispatcherForLinkedImage());
      }
    }
    /**
     * Processes transformed {@link module:link/utils~ManualDecorator} instances and attaches proper converters
     * that will work when linking an image.
     *
     * @private
     */

  }, {
    key: "_enableManualDecorators",
    value: function _enableManualDecorators() {
      var editor = this.editor;
      var command = editor.commands.get('link');
      var manualDecorators = command.manualDecorators;

      var _iterator = _createForOfIteratorHelper(command.manualDecorators),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var decorator = _step.value;

          if (editor.plugins.has('ImageBlockEditing')) {
            editor.model.schema.extend('imageBlock', {
              allowAttributes: decorator.id
            });
          }

          if (editor.plugins.has('ImageInlineEditing')) {
            editor.model.schema.extend('imageInline', {
              allowAttributes: decorator.id
            });
          }

          editor.conversion.for('downcast').add(downcastImageLinkManualDecorator(manualDecorators, decorator));
          editor.conversion.for('upcast').add(upcastImageLinkManualDecorator(manualDecorators, decorator));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }], [{
    key: "requires",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return ['ImageEditing', 'ImageUtils', LinkEditing];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "pluginName",
    get: function get() {
      return 'LinkImageEditing';
    }
  }]);

  return LinkImageEditing;
}(Plugin); // Returns a converter for linked block images that consumes the "href" attribute
// if a link contains an image.
//
// @private
// @param {module:core/editor/editor~Editor} editor The editor instance.
// @returns {Function}


export { LinkImageEditing as default };

function upcastLink(editor) {
  var isImageInlinePluginLoaded = editor.plugins.has('ImageInlineEditing');
  var linkUtils = editor.plugins.get('ImageUtils');
  return function (dispatcher) {
    dispatcher.on('element:a', function (evt, data, conversionApi) {
      var viewLink = data.viewItem;
      var imageInLink = getFirstImage(viewLink);

      if (!imageInLink) {
        return;
      }

      var blockImageView = imageInLink.findAncestor(function (element) {
        return linkUtils.isBlockImageView(element);
      }); // There are two possible cases to consider here
      //
      // 1. A "root > ... > figure.image > a > img" structure.
      // 2. A "root > ... > block > a > img" structure.
      //
      // but the latter should only be considered by this converter when the inline image plugin
      // is NOT loaded in the editor (because otherwise, that would be a plain, linked inline image).

      if (isImageInlinePluginLoaded && !blockImageView) {
        return;
      } // There's an image inside an <a> element - we consume it so it won't be picked up by the Link plugin.


      var consumableAttributes = {
        attributes: ['href']
      }; // Consume the `href` attribute so the default one will not convert it to $text attribute.

      if (!conversionApi.consumable.consume(viewLink, consumableAttributes)) {
        // Might be consumed by something else - i.e. other converter with priority=highest - a standard check.
        return;
      }

      var linkHref = viewLink.getAttribute('href'); // Missing the 'href' attribute.

      if (!linkHref) {
        return;
      } // A full definition of the image feature.
      // figure > a > img: parent of the view link element is an image element (figure).


      var modelElement = data.modelCursor.parent;

      if (!modelElement.is('element', 'imageBlock')) {
        // a > img: parent of the view link is not the image (figure) element. We need to convert it manually.
        var conversionResult = conversionApi.convertItem(imageInLink, data.modelCursor); // Set image range as conversion result.

        data.modelRange = conversionResult.modelRange; // Continue conversion where image conversion ends.

        data.modelCursor = conversionResult.modelCursor;
        modelElement = data.modelCursor.nodeBefore;
      }

      if (modelElement && modelElement.is('element', 'imageBlock')) {
        // Set the linkHref attribute from link element on model image element.
        conversionApi.writer.setAttribute('linkHref', linkHref, modelElement);
      }
    }, {
      priority: 'high'
    }); // Using the same priority that `upcastImageLinkManualDecorator()` converter guarantees
    // that manual decorators will decorate the proper element.
  };
} // Creates a converter that adds `<a>` to linked block image view elements.
//
// @private


function downcastImageLink(dispatcher) {
  dispatcher.on('attribute:linkHref:imageBlock', function (evt, data, conversionApi) {
    // The image will be already converted - so it will be present in the view.
    var viewFigure = conversionApi.mapper.toViewElement(data.item);
    var writer = conversionApi.writer; // But we need to check whether the link element exists.

    var linkInImage = Array.from(viewFigure.getChildren()).find(function (child) {
      return child.name === 'a';
    }); // If so, update the attribute if it's defined or remove the entire link if the attribute is empty.

    if (linkInImage) {
      if (data.attributeNewValue) {
        writer.setAttribute('href', data.attributeNewValue, linkInImage);
      } else {
        var viewImage = Array.from(linkInImage.getChildren()).find(function (child) {
          return child.name === 'img';
        });
        writer.move(writer.createRangeOn(viewImage), writer.createPositionAt(viewFigure, 0));
        writer.remove(linkInImage);
      }
    } else {
      // But if it does not exist. Let's wrap already converted image by newly created link element.
      // 1. Create an empty link element.
      var linkElement = writer.createContainerElement('a', {
        href: data.attributeNewValue
      }); // 2. Insert link inside the associated image.

      writer.insert(writer.createPositionAt(viewFigure, 0), linkElement); // 3. Move the image to the link.

      writer.move(writer.createRangeOn(viewFigure.getChild(1)), writer.createPositionAt(linkElement, 0));
    }
  });
} // Returns a converter that decorates the `<a>` element when the image is the link label.
//
// @private
// @returns {Function}


function downcastImageLinkManualDecorator(manualDecorators, decorator) {
  return function (dispatcher) {
    dispatcher.on("attribute:".concat(decorator.id, ":imageBlock"), function (evt, data, conversionApi) {
      var attributes = manualDecorators.get(decorator.id).attributes;
      var viewFigure = conversionApi.mapper.toViewElement(data.item);
      var linkInImage = Array.from(viewFigure.getChildren()).find(function (child) {
        return child.name === 'a';
      }); // The <a> element was removed by the time this converter is executed.
      // It may happen when the base `linkHref` and decorator attributes are removed
      // at the same time (see #8401).

      if (!linkInImage) {
        return;
      }

      var _iterator2 = _createForOfIteratorHelper(toMap(attributes)),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _ref3 = _step2.value;

          var _ref2 = _slicedToArray(_ref3, 2);

          var key = _ref2[0];
          var val = _ref2[1];
          conversionApi.writer.setAttribute(key, val, linkInImage);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    });
  };
} // Returns a converter that checks whether manual decorators should be applied to the link.
//
// @private
// @returns {Function}


function upcastImageLinkManualDecorator(manualDecorators, decorator) {
  return function (dispatcher) {
    dispatcher.on('element:a', function (evt, data, conversionApi) {
      var viewLink = data.viewItem;
      var imageInLink = getFirstImage(viewLink); // We need to check whether an image is inside a link because the converter handles
      // only manual decorators for linked images. See #7975.

      if (!imageInLink) {
        return;
      }

      var consumableAttributes = {
        attributes: manualDecorators.get(decorator.id).attributes
      };
      var matcher = new Matcher(consumableAttributes);
      var result = matcher.match(viewLink); // The link element does not have required attributes or/and proper values.

      if (!result) {
        return;
      } // Check whether we can consume those attributes.


      if (!conversionApi.consumable.consume(viewLink, result.match)) {
        return;
      } // At this stage we can assume that we have the `<imageBlock>` element.
      // `nodeBefore` comes after conversion: `<a><img></a>`.
      // `parent` comes with full image definition: `<figure><a><img></a></figure>.
      // See the body of the `upcastLink()` function.


      var modelElement = data.modelCursor.nodeBefore || data.modelCursor.parent;
      conversionApi.writer.setAttribute(decorator.id, true, modelElement);
    }, {
      priority: 'high'
    }); // Using the same priority that `upcastLink()` converter guarantees that the linked image was properly converted.
  };
} // Returns the first image in a given view element.
//
// @private
// @param {module:engine/view/element~Element}
// @returns {module:engine/view/element~Element|undefined}


function getFirstImage(viewElement) {
  return Array.from(viewElement.getChildren()).find(function (child) {
    return child.name === 'img';
  });
}